// @flow
import React, {Component} from 'react';
import {StyleSheet, View, Platform} from 'react-native';
import {Separator} from 'trpc-react-native-ui';
import theme from '../../../theme-config';
import PlanSummaryFrame from '../../plan/PlanSummaryFrame';
import {FlatList} from '../FlatList';
import PageTitle from '../../signUp/PageTitle';
import {Choice, NewPlanWithNewNumber} from './components';
import config from '../../../config';

import type {Subscription} from 'digicel-kaizen-library';

class SelectSubscriptionPage extends Component<Props, State> {
  componentDidMount() {
    const {subscriptions, setSubscriptionToUpdate} = this.props;
    if (
      subscriptions.length > 0 &&
      subscriptions[0].hasUnavailableOffers &&
      setSubscriptionToUpdate
    ) {
      setSubscriptionToUpdate(subscriptions[0].ouid);
    }
  }

  state = {
    isNewLineSelected: false,
    currentSubscription: this.props.subscriptions[0],
  };

  styles = getStyles();

  selectNewPlanWithNewNumber = () => {
    this.setState({isNewLineSelected: true});
    this.setState({currentSubscription: null});
    if (this.props.setSubscriptionToUpdate) {
      this.props.setSubscriptionToUpdate();
    }
  };

  onPlanSummaryFrame = (subscription: Subscription) => {
    this.setState({isNewLineSelected: false});
    this.setState({currentSubscription: subscription});
  };

  createLine = () =>
    this.props.canCreateNewLine ? (
      <Choice isChosen={this.state.isNewLineSelected}>
        {isChosen => (
          <NewPlanWithNewNumber
            onPress={this.selectNewPlanWithNewNumber}
            isHighlighted={isChosen}
            style={this.styles.planSummaryFrame}
          />
        )}
      </Choice>
    ) : null;

  isSubscriptionSelected = (subscription: Subscription) => {
    return this.state.currentSubscription === subscription;
  };

  onPressPrimaryButton = () => {
    if (this.props.setSubscriptionToUpdate) {
      if (this.state.currentSubscription && this.state.currentSubscription.hasUnavailableOffers) {
        this.props.setSubscriptionToUpdate(this.state.currentSubscription.ouid);
      } else {
        this.props.setSubscriptionToUpdate();
      }
    }
    this.props.onPressPrimaryButton(this.state.currentSubscription);
  };

  renderSubscriptionChoice = (itemInfo: {
    item: Subscription,
    index: number,
  }): * => {
    const {item, index} = itemInfo;

    return (
      <Choice
        isChosen={
          !this.state.isNewLineSelected && this.isSubscriptionSelected(item)
        }>
        {isChosen => (
          <PlanSummaryFrame
            subscription={item}
            style={[
              this.styles.planSummaryFrame,
              index === 0 && this.styles.firstPlanSummaryFrame,
            ]}
            onPress={this.onPlanSummaryFrame}
            isHighlighted={isChosen}
            isActivation={this.props.isActivation}
            showPortabilityNextToNumber
            showSubscriptionsWithoutPhoneNumber
            setSubscriptionToUpdate={this.props.setSubscriptionToUpdate}
          />
        )}
      </Choice>
    );
  };

  render() {
    const styles = this.styles;
    const {PrimaryButton, SecondaryButton, style} = this.props;

    return (
      <View style={[styles.pageContainer, style]}>
        <View style={styles.title}>
          <PageTitle title={this.props.title} style={styles.pageTitle} />
        </View>
        <FlatList
          data={this.props.subscriptions}
          extraData={{currentSubscription: this.state.currentSubscription}}
          renderItem={this.renderSubscriptionChoice}
          keyExtractor={item => item.ouid}
          ListFooterComponent={this.createLine()}
        />
        <Separator />
        {SecondaryButton && <SecondaryButton style={styles.secondaryButton} />}
        {PrimaryButton && (
          <PrimaryButton
            style={styles.primaryButton}
            subscription={this.state.currentSubscription}
            onPress={this.onPressPrimaryButton}
          />
        )}
      </View>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    pageContainer: {
      flex: 1,
    },
    title: {
      marginHorizontal: Platform.OS === 'ios' ? 40 : 22,
      marginBottom: 20,
      marginTop: Platform.OS === 'ios' ? 10 : 0,
    },
    planSummaryFrame: {
      borderBottomWidth: 1,
      borderColor: theme.gray.normalLight,
      borderRadius: 0,
      paddingLeft: config.displayRoamingPlanSliders ? 25 : 0,
    },
    firstPlanSummaryFrame: {
      borderTopWidth: 1,
    },
    pageTitle: {
      fontSize: 18,
    },
    primaryButton: {
      margin: 17,
    },
    secondaryButton: {
      marginTop: 17,
      marginHorizontal: 17,
    },
  });
}

type Props = DispatchProps & OwnProps;

type State = {
  isNewLineSelected: boolean,
  currentSubscription: ?Subscription,
};

export type DispatchProps = {
  onPressPrimaryButton: (?Subscription) => any,
};

export type OwnProps = {
  subscriptions: Subscription[],
  title: string,
  style?: Object,
  PrimaryButton?: any,
  SecondaryButton?: any,
  canCreateNewLine?: boolean,
  isActivation?: boolean,
  setSubscriptionToUpdate?: Function,
};

export default SelectSubscriptionPage;
